define('header',['jquery', 'underscore', 'event-manager', 'lib', 'jsx!components/survey-banner/main'], function($, _, eventManager, lib, SurveyBanner) {
    'use strict';

    var $html;
    var $dropdowns;
    var isInitialized;
    var Header = {
        initMenu: function() {
            $html = lib.$html();
            var closeMenu = function(e) {
                if ($(e.target).closest('#e24nav, #tickerContainer, .main-nav, .main-bors').length === 0) {
                    if (lib.isMobile()) {
                        e.preventDefault();
                    }
                    $html.removeClass('menu-open');
                    $html.removeClass('bors-open');
                    lib.$document().off('.menu');
                }
            };

            lib.$('#e24nav').on('click', _.bind(function() {
                this.setDropdowns();

                if (!isInitialized) {
                    if (lib.isMobile() || lib.isTablet()) {
                        this.initTouch();
                    } else {
                        this.initDesktop();
                    }

                    isInitialized = true;
                }

                if ($html.hasClass('menu-open')) {
                    $(this).attr('data-stats-type', '');
                    $html.removeClass('menu-open');
                    $dropdowns.removeClass('active');
                    lib.$document().off('.menu');
                } else {
                    $(this).attr('data-stats-type', 'navigation');
                    $html.addClass('menu-open');
                    $html.removeClass('bors-open');
                    lib.$document().on('click.menu', closeMenu);
                }
            }, this));

            var opened = false;
            lib.$('#tickerContainer').on('click', function(e) {
                if ($(e.target).closest('.ticker').length) {
                    if (lib.isMobile()) {
                        e.preventDefault();
                    } else {
                        return;
                    }
                }

                if ($html.hasClass('bors-open')) {
                    $(this).attr('data-stats-type', '');
                    $html.removeClass('bors-open');
                    lib.$document().off('.menu');
                } else {
                    $(this).attr('data-stats-type', 'navigation');
                    $html.addClass('bors-open');
                    $html.removeClass('menu-open');
                    lib.$document().on('click.menu', closeMenu);
                    if (!opened) {
                        opened = true;
                    }
                }
            });
        },

        initTickers: function() {
            var container = lib.$('#tickerContainer');
            var tickers = [];

            if (container.length) {
                if (!lib.isMobile()) {
                    tickers = [
                        { name: 'Oslo', ticker: 'OSEBX.OSE' },
                        { name: 'Olje', ticker: 'C:PBROUSDBR\\SP.IDCENE' },
                        { name: 'S&P', ticker: 'I:SP500.SP' },
                        // { name: 'FTSE 100', ticker: 'I:UKX.FTSE' },
                        // { name: 'Nikkei', ticker: 'NI225.OSA' },
                        { name: 'Euro', ticker: 'X:SEURNOK.IDCFX' },
                        { name: 'Dollar', ticker: 'X:SUSDNOK.IDCFX' },
                        { name: 'Bitcoin', ticker: 'BTC.CRYPTO' },
                    ];
                } else {
                    var date = new Date();
                    var hour = date.getUTCHours();

                    if (hour >= 7 && hour < 17) {
                        tickers = [{ name: 'Oslo', ticker: 'OSEBX.OSE' }];
                    } else if (hour >= 1 && hour < 7) {
                        tickers = [{ name: 'Nikkei', ticker: 'NI225.OSA' }];
                    } else {
                        tickers = [{ name: 'S&P', ticker: 'I:SP500.SP' }];
                    }

                    tickers.push({ name: 'Olje', ticker: 'C:PBROUSDBR\\SP.IDCENE' });
                }
            }
        },

        initDesktop: function() {
            $dropdowns.on('mouseover', function() {
                $(this).addClass('active');
            }).on('mouseout', function() {
                $(this).removeClass('active');
            });
        },

        initSurvey: function() {
            SurveyBanner({
                active: false,
                surveyName: 'sporreundersokelse150318',
                targets: [],
                link: 'https://mipro.li/w2GFd35',
                body: 'Hei. Vi gjennomfører for tiden en liten undersøkelse om sparevaner.',
                disclaimer: 'Kunne du tenke deg å bruke 5-6 minutter til hjelpe oss å svare på denne?',
                buttonTexts: {
                    accept: 'Ja takk!',
                    dismiss: 'Nei'
                }
            });
        },

        initTouch: function() {
            var $dropdownAnchors = $dropdowns.find(' > a, > span');

            $dropdownAnchors.on('click', function(e) {
                e.preventDefault();
                var parent = $(this).parent();
                if (parent.hasClass('active')) {
                    parent.removeClass('active');
                } else {
                    $dropdowns.removeClass('active');
                    parent.addClass('active');
                }
            });
        },

        setDropdowns: function() {
            if (!$dropdowns || !$dropdowns.length) {
                $dropdowns = lib.$('#e24header').find('.main-nav > li.dropdown');
            }
        },
    };

    _.bindAll(Header, _.methods(Header));

    eventManager.once('domready', function() {
        if (!lib.isApp()) {
            Header.initMenu();
            Header.initTickers();
            Header.initSurvey();
        }
    });

    return Header;
});

